import { Outlet } from "react-router-dom";
import {
   TopBar,
   Navbar,
   Footer} from 
  '../components/web-app/index'

  import BackToTop from "./BackToTop/backtotop";

const WebWrapperLayout = () => {
  return (
    <>
      <TopBar />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
};

export default WebWrapperLayout;